import axios from 'axios'
import { API_URL } from '../../../../constants'

export interface TransferTarget {
  id: number
  name: string
  currency: string
  cashBoxId: number
  fastTrackEnabled: boolean
  fastTrackMaxClients: number
  currentClientsCount: number
  intersectionCount: number
}

export interface TransferTargetsResponse {
  success: boolean
  data: {
    sourceClientsCount: number
    globalLimit: number
    targets: TransferTarget[]
  } | null
}

export interface BulkTransferResponse {
  success: boolean
  data: {
    transferredCount: number
    intersectionCount: number
    newAssignmentsCount: number
    sourceRequisiteId: number
    targetRequisiteId: number
  } | null
  errors?: Record<string, string>
}

export const toggleClientRequisite = (requisiteId: string | number, clientId: number) =>
  axios.post(`${API_URL}/api/internal/requisite/${requisiteId}/toggle-client/${clientId}`)

export const getAssignedClients = (
  requisiteId: string | number,
  params: { page: number; perPage: number; search?: string }
) =>
  axios.get(`${API_URL}/api/internal/external_user/list`, {
    params: { requisiteId, ...params },
  })

export const getTransferTargets = (requisiteId: string | number) =>
  axios.get<TransferTargetsResponse>(
    `${API_URL}/api/internal/requisite/${requisiteId}/transfer-targets`
  )

export const bulkTransferClients = (
  requisiteId: string | number,
  targetRequisiteId: number
) =>
  axios.post<BulkTransferResponse>(
    `${API_URL}/api/internal/requisite/${requisiteId}/bulk-transfer-clients`,
    { targetRequisiteId }
  )
